import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Spinner, Input, Label, FormGroup, Alert
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const EMPTY_FORM = {
  ID: null,
  KULLANICI_ID: "",
  KATEGORI_ID: "",
  ILAN_HAKKI: 0,
  DEGERLEME_HAKKI: 0,
  MEZAT_HAKKI: 0,
  MEZAT_UZATMA_HAKKI: 0,
};

const KullaniciKategoriHaklari = () => {
  document.title = "Kategori Bazlı Haklar | HarmanaGEL";

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };

  const [liste, setListe] = useState([]);
  const [kullanicilar, setKullanicilar] = useState([]);
  const [kategoriler, setKategoriler] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [filterUserId, setFilterUserId] = useState("");

  const [modal, setModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [formData, setFormData] = useState(EMPTY_FORM);

  const fetchListe = async (userIdFilter = "") => {
    setIsLoading(true);
    setError(null);
    try {
      let url = `${BASE_URL}/KULLANICI_KATEGORI_HAKLARI?$expand=KULLANICILAR,KATEGORILER&$orderby=ID desc&$top=2000`;
      if (userIdFilter) {
        url = `${BASE_URL}/KULLANICI_KATEGORI_HAKLARI?$filter=KULLANICI_ID eq ${userIdFilter}&$expand=KULLANICILAR,KATEGORILER&$orderby=KATEGORI_ID asc&$top=2000`;
      }
      const res = await fetch(url, { headers });
      const result = await res.json();
      setListe(result.value || []);
    } catch {
      setError("Liste yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLookups = async () => {
    try {
      const [resKul, resKat, resBag] = await Promise.all([
        fetch(`${BASE_URL}/KULLANICILAR?$select=ID,AD_SOYAD,Mail_Adress&$orderby=ID desc&$top=10000`, { headers }),
        fetch(`${BASE_URL}/KATEGORILER?$select=ID,AD&$orderby=SIRA_NO asc`, { headers }),
        fetch(`${BASE_URL}/KATEGORI_BAGLANTILARI?$select=ALT_KATEGORI_ID&$top=10000`, { headers }),
      ]);
      const kulJson = await resKul.json();
      const katJson = await resKat.json();
      const bagJson = await resBag.json();
      const altIds = new Set((bagJson.value || []).map(b => b.ALT_KATEGORI_ID));
      setKullanicilar(kulJson.value || []);
      setKategoriler((katJson.value || []).filter(k => !altIds.has(k.ID)));
    } catch {
      // sessizce gec
    }
  };

  useEffect(() => { fetchListe(); fetchLookups(); }, []);

  const openAdd = () => {
    setFormData(EMPTY_FORM);
    setIsEditing(false);
    setModal(true);
  };

  const handleEdit = (row) => {
    setFormData({
      ID: row.ID,
      KULLANICI_ID: row.KULLANICI_ID,
      KATEGORI_ID: row.KATEGORI_ID,
      ILAN_HAKKI: row.ILAN_HAKKI ?? 0,
      DEGERLEME_HAKKI: row.DEGERLEME_HAKKI ?? 0,
      MEZAT_HAKKI: row.MEZAT_HAKKI ?? 0,
      MEZAT_UZATMA_HAKKI: row.MEZAT_UZATMA_HAKKI ?? 0,
    });
    setIsEditing(true);
    setModal(true);
  };

  const handleSave = async () => {
    if (!formData.KULLANICI_ID || !formData.KATEGORI_ID) {
      setError("Kullanıcı ve kategori zorunlu.");
      return;
    }
    setIsSaving(true);
    try {
      const payload = {
        KULLANICI_ID: Number(formData.KULLANICI_ID),
        KATEGORI_ID: Number(formData.KATEGORI_ID),
        ILAN_HAKKI: Number(formData.ILAN_HAKKI) || 0,
        DEGERLEME_HAKKI: Number(formData.DEGERLEME_HAKKI) || 0,
        MEZAT_HAKKI: Number(formData.MEZAT_HAKKI) || 0,
        MEZAT_UZATMA_HAKKI: Number(formData.MEZAT_UZATMA_HAKKI) || 0,
        SON_GUNCELLEME: new Date().toISOString(),
      };

      if (isEditing) {
        await fetch(`${BASE_URL}/KULLANICI_KATEGORI_HAKLARI(${formData.ID})`, {
          method: "PATCH", headers, body: JSON.stringify(payload),
        });
        setSuccessMsg("Hak kaydı güncellendi.");
      } else {
        payload.OLUSTURMA_TARIHI = new Date().toISOString();
        await fetch(`${BASE_URL}/KULLANICI_KATEGORI_HAKLARI`, {
          method: "POST", headers, body: JSON.stringify(payload),
        });
        setSuccessMsg("Hak kaydı eklendi.");
      }

      setModal(false);
      fetchListe(filterUserId);
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("Kayıt sırasında hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Bu kategori hak kaydını silmek istediğinize emin misiniz?")) return;
    try {
      await fetch(`${BASE_URL}/KULLANICI_KATEGORI_HAKLARI(${id})`, { method: "DELETE", headers });
      setSuccessMsg("Kayıt silindi.");
      fetchListe(filterUserId);
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("Silme sırasında hata oluştu.");
    }
  };

  const columns = useMemo(() => [
    {
      header: "#",
      accessorKey: "ID",
      enableSorting: true,
      cell: (c) => <strong>#{c.getValue()}</strong>,
    },
    {
      header: "Kullanıcı",
      accessorKey: "KULLANICI_ID",
      enableSorting: true,
      cell: (c) => {
        const u = c.row.original.KULLANICILAR;
        return (
          <div>
            <div className="fw-medium">{u?.AD_SOYAD || `#${c.getValue()}`}</div>
            <small className="text-muted">{u?.Mail_Adress}</small>
          </div>
        );
      },
    },
    {
      header: "Kategori",
      accessorKey: "KATEGORI_ID",
      enableSorting: true,
      cell: (c) => {
        const k = c.row.original.KATEGORILER;
        return <Badge color="secondary" pill>{k?.AD || `#${c.getValue()}`}</Badge>;
      },
    },
    {
      header: "İlan",
      accessorKey: "ILAN_HAKKI",
      enableSorting: true,
      cell: (c) => <Badge color="info">{c.getValue() ?? 0}</Badge>,
    },
    {
      header: "Mezat",
      accessorKey: "MEZAT_HAKKI",
      enableSorting: true,
      cell: (c) => <Badge color="warning">{c.getValue() ?? 0}</Badge>,
    },
    {
      header: "Uzatma",
      accessorKey: "MEZAT_UZATMA_HAKKI",
      enableSorting: true,
      cell: (c) => <Badge color="dark">{c.getValue() ?? 0}</Badge>,
    },
    {
      header: "Değerleme",
      accessorKey: "DEGERLEME_HAKKI",
      enableSorting: true,
      cell: (c) => <Badge color="success">{c.getValue() ?? 0}</Badge>,
    },
    {
      header: "İşlemler",
      enableSorting: false,
      cell: (cellProps) => {
        const row = cellProps.row.original;
        return (
          <div className="d-flex gap-2">
            <Button color="primary" size="sm" outline onClick={() => handleEdit(row)}>
              <i className="bx bx-edit" />
            </Button>
            <Button color="danger" size="sm" outline onClick={() => handleDelete(row.ID)}>
              <i className="bx bx-trash" />
            </Button>
          </div>
        );
      },
    },
  ], []);

  const f = (field, val) => setFormData(p => ({ ...p, [field]: val }));

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kategori Bazlı Haklar" />

          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <div>
                      <h4 className="card-title mb-1">Kategori Bazlı Kullanıcı Hakları</h4>
                      <p className="text-muted small mb-0">
                        Her kullanıcının her ana kategorideki ilan/mezat/uzatma/değerleme haklarını buradan yönetin.
                      </p>
                    </div>
                    <div className="d-flex gap-2 align-items-center">
                      <Input
                        type="select"
                        bsSize="sm"
                        value={filterUserId}
                        onChange={(e) => {
                          setFilterUserId(e.target.value);
                          fetchListe(e.target.value);
                        }}
                        style={{ minWidth: 240 }}
                      >
                        <option value="">— Tüm kullanıcılar —</option>
                        {kullanicilar.map(u => (
                          <option key={u.ID} value={u.ID}>
                            {u.AD_SOYAD || u.Mail_Adress} (#{u.ID})
                          </option>
                        ))}
                      </Input>
                      <Button color="primary" size="sm" onClick={openAdd}>
                        <i className="bx bx-plus me-1" />Yeni Kayıt
                      </Button>
                    </div>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={liste}
                      isGlobalFilter={true}
                      isPagination={true}
                      customPageSize={20}
                      SearchPlaceholder="Kullanıcı veya kategori ara..."
                      tableClass="align-middle table-nowrap table-hover"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      pagination="pagination pagination-rounded justify-content-end mb-2"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <Modal isOpen={modal} toggle={() => setModal(false)} centered size="lg">
        <ModalHeader toggle={() => setModal(false)}>
          <i className="mdi mdi-account-key-outline me-2 text-primary"></i>
          {isEditing ? `Hak Kaydını Düzenle (#${formData.ID})` : "Yeni Hak Kaydı"}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label className="fw-bold">Kullanıcı <span className="text-danger">*</span></Label>
                <Input
                  type="select"
                  value={formData.KULLANICI_ID}
                  onChange={(e) => f("KULLANICI_ID", e.target.value)}
                  disabled={isEditing}
                >
                  <option value="">— Seçin —</option>
                  {kullanicilar.map(u => (
                    <option key={u.ID} value={u.ID}>
                      {u.AD_SOYAD || u.Mail_Adress} (#{u.ID})
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label className="fw-bold">Ana Kategori <span className="text-danger">*</span></Label>
                <Input
                  type="select"
                  value={formData.KATEGORI_ID}
                  onChange={(e) => f("KATEGORI_ID", e.target.value)}
                  disabled={isEditing}
                >
                  <option value="">— Seçin —</option>
                  {kategoriler.map(k => (
                    <option key={k.ID} value={k.ID}>{k.AD}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label className="fw-bold">İlan Hakkı</Label>
                <Input
                  type="number" min="0"
                  value={formData.ILAN_HAKKI}
                  onChange={(e) => f("ILAN_HAKKI", e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label className="fw-bold">Değerleme Hakkı</Label>
                <Input
                  type="number" min="0"
                  value={formData.DEGERLEME_HAKKI}
                  onChange={(e) => f("DEGERLEME_HAKKI", e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label className="fw-bold">Mezat Hakkı</Label>
                <Input
                  type="number" min="0"
                  value={formData.MEZAT_HAKKI}
                  onChange={(e) => f("MEZAT_HAKKI", e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label className="fw-bold">Mezat Uzatma Hakkı</Label>
                <Input
                  type="number" min="0"
                  value={formData.MEZAT_UZATMA_HAKKI}
                  onChange={(e) => f("MEZAT_UZATMA_HAKKI", e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setModal(false)} disabled={isSaving}>İptal</Button>
          <Button color="primary" onClick={handleSave} disabled={isSaving}>
            {isSaving ? <Spinner size="sm" className="me-1" /> : <i className="mdi mdi-content-save me-1"></i>}
            {isEditing ? "Güncelle" : "Kaydet"}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default KullaniciKategoriHaklari;
